import { DeepPartial, RelatedTagsConfig } from '@empathybroker/ebx-gluon';


export const MOBILE_RELATED_TAGS_CONFIG: DeepPartial<RelatedTagsConfig> = {
  selectable: true,
  components: {
    relatedTags: {
      selectedTagContent: 'TuandcoCloseIcon'
    }
  },
  relatedTags: {
    showSelectedValues: true,
  }
};
